import { fromJS } from 'immutable';
import * as types from '../constants/index';

const initialState = fromJS({
  headerInfo: {},
  stripMatch: {},
  stripMatches: {},
});

export default function headerInfoReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_HEADER_INFO_SUCCESS:
      return {
        ...state,
        headerInfo: action.data,
      };
    case types.GET_STRIP_MATCH_SUCCESS:
      return state.mergeIn(['stripMatches'], { [action.widgetId]: fromJS(action.data) });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/headerInfo.js